import "core-js/modules/es6.regexp.replace";
import "core-js/modules/web.dom.iterable";
import "core-js/modules/es6.object.keys";
import "core-js/modules/es6.regexp.to-string";
import "core-js/modules/es6.date.to-string";
import "core-js/modules/es6.object.to-string";
import "core-js/modules/es7.array.includes";
import "core-js/modules/es6.string.includes";
import "core-js/modules/es6.array.iterator";
import "core-js/modules/es6.promise";
import "core-js/modules/es6.object.assign";
import "core-js/modules/es7.promise.finally";

var registerStoreModule = function registerStoreModule(store, moduleName, moduleObject) {
  var preserve = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : false;

  if (!Object.keys(store.getters).toString().includes(moduleName)) {
    store.registerModule(moduleName.replace('/', ''), moduleObject, {
      preserveState: preserve
    });
  }
};

export default registerStoreModule;